import axios from 'axios'
import {
  API_BASE_URL,
  SLIDES_GET_ALL_SLIDES_URL,
  SLIDES_ADD_NEW_SLIDE_URL, SLIDES_UPDATE_SLIDE_URL, SLIDES_DELETE_SLIDE_URL, ABOUT_GET_INFO_ABOUT_URL, ABOUT_UPDATE_INFO_ABOUT_URL, GALLERY_UPDATE_IMAGES_URL, SERVICES_GET_ALL_SERVICES_URL, SERVICES_ADD_NEW_SERVICE_URL, SERVICES_DELETE_SERVICE_URL, PROJECTS_GET_ALL_PROJECTS_URL, PROJECTS_ADD_NEW_PROJECT_URL, PROJECTS_UPDATE_PROJECT_URL, PROJECTS_DELETE_PROJECT_URL, MEMBERS_GET_ALL_MEMBERS_URL, MEMBERS_ADD_NEW_MEMBER_URL, MEMBERS_UPDATE_MEMBER_URL, MEMBERS_DELETE_MEMBER_URL, SERVICES_UPDATE_SERVICE_URL
} from '../variables'
import { SLIDES_GET_ALL_SLIDES, SLIDES_ADD_NEW_SLIDE, SLIDES_UPDATE_SLIDE, SLIDES_DELETE_SLIDE, ABOUT_GET_INFO_ABOUT, ABOUT_UPDATE_INFO_ABOUT, GALLERY_UPDATE_IMAGES, SERVICES_GET_ALL_SERVICES, SERVICES_ADD_NEW_SERVICE, SERVICES_UPDATE_SERVICE, SERVICES_DELETE_SERVICE, PROJECTS_GET_ALL_PROJECTS, PROJECTS_ADD_NEW_PROJECT, PROJECTS_UPDATE_PROJECT, PROJECTS_DELETE_PROJECT, MEMBERS_GET_ALL_MEMBERS, MEMBERS_ADD_NEW_MEMBER, MEMBERS_UPDATE_MEMBER, MEMBERS_DELETE_MEMBER } from '../actions/customizations'

const state = {}
const getters = {}
const mutations = {}
const actions = {
  //slides
  [SLIDES_GET_ALL_SLIDES]: ({ commit, state, getters }, payload) => {
    return axios({
      url: API_BASE_URL + SLIDES_GET_ALL_SLIDES_URL,
      method: 'GET',
      headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
    })
  },
  [SLIDES_ADD_NEW_SLIDE]: ({ commit, state, getters }, payload) => {
    return axios({
      url: API_BASE_URL + SLIDES_ADD_NEW_SLIDE_URL,
      method: 'POST',
      data: payload,
      headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
    })
  },
  [SLIDES_UPDATE_SLIDE]: ({ commit, state, getters }, payload) => {
    return axios({
      url: API_BASE_URL + SLIDES_UPDATE_SLIDE_URL + payload.id,
      method: 'PUT',
      data: payload,
      headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
    })
  },
  [SLIDES_DELETE_SLIDE]: ({ commit, state, getters }, payload) => {
    return axios({
      url: API_BASE_URL + SLIDES_DELETE_SLIDE_URL + payload.id,
      method: 'DELETE',
      headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
    })
  },
  // about
  [ABOUT_GET_INFO_ABOUT]: ({ commit, state, getters }, payload) => {
    return axios({
      url: API_BASE_URL + ABOUT_GET_INFO_ABOUT_URL,
      method: 'GET',
      headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
    })
  },
  [ABOUT_UPDATE_INFO_ABOUT]: ({ commit, state, getters }, payload) => {
    return axios({
      url: API_BASE_URL + ABOUT_UPDATE_INFO_ABOUT_URL,
      method: 'PUT',
      data: payload,
      headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
    })
  },
  [GALLERY_UPDATE_IMAGES]: ({ commit, state, getters }, payload) => {
    return axios({
      url: API_BASE_URL + GALLERY_UPDATE_IMAGES_URL,
      method: 'POST',
      data: payload,
      headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
    })
  },
  // services
  [SERVICES_GET_ALL_SERVICES]: ({ commit, state, getters }, payload) => {
    return axios({
      url: API_BASE_URL + SERVICES_GET_ALL_SERVICES_URL,
      method: 'GET',
      headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
    })
  },
  [SERVICES_ADD_NEW_SERVICE]: ({ commit, state, getters }, payload) => {
    return axios({
      url: API_BASE_URL + SERVICES_ADD_NEW_SERVICE_URL,
      method: 'POST',
      data: payload,
      headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
    })
  },
  [SERVICES_UPDATE_SERVICE]: ({ commit, state, getters }, payload) => {
    return axios({
      url: API_BASE_URL + SERVICES_UPDATE_SERVICE_URL + payload.id,
      method: 'PUT',
      data: payload,
      headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
    })
  },
  [SERVICES_DELETE_SERVICE]: ({ commit, state, getters }, payload) => {
    return axios({
      url: API_BASE_URL + SERVICES_DELETE_SERVICE_URL + payload.id,
      method: 'DELETE',
      headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
    })
  },
  // projects
  [PROJECTS_GET_ALL_PROJECTS]: ({ commit, state, getters }, payload) => {
    return axios({
      url: API_BASE_URL + PROJECTS_GET_ALL_PROJECTS_URL,
      method: 'GET',
      headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
    })
  },
  [PROJECTS_ADD_NEW_PROJECT]: ({ commit, state, getters }, payload) => {
    return axios({
      url: API_BASE_URL + PROJECTS_ADD_NEW_PROJECT_URL,
      method: 'POST',
      data: payload,
      headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
    })
  },
  [PROJECTS_UPDATE_PROJECT]: ({ commit, state, getters }, payload) => {
    return axios({
      url: API_BASE_URL + PROJECTS_UPDATE_PROJECT_URL + payload.id,
      method: 'PUT',
      data: payload,
      headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
    })
  },
  [PROJECTS_DELETE_PROJECT]: ({ commit, state, getters }, payload) => {
    return axios({
      url: API_BASE_URL + PROJECTS_DELETE_PROJECT_URL + payload.id,
      method: 'DELETE',
      headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
    })
  },
  // members
  [MEMBERS_GET_ALL_MEMBERS]: ({ commit, state, getters }, payload) => {
    return axios({
      url: API_BASE_URL + MEMBERS_GET_ALL_MEMBERS_URL,
      method: 'GET',
      headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
    })
  },
  [MEMBERS_ADD_NEW_MEMBER]: ({ commit, state, getters }, payload) => {
    return axios({
      url: API_BASE_URL + MEMBERS_ADD_NEW_MEMBER_URL,
      method: 'POST',
      data: payload,
      headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
    })
  },
  [MEMBERS_UPDATE_MEMBER]: ({ commit, state, getters }, payload) => {
    return axios({
      url: API_BASE_URL + MEMBERS_UPDATE_MEMBER_URL + payload.id,
      method: 'PUT',
      data: payload,
      headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
    })
  },
  [MEMBERS_DELETE_MEMBER]: ({ commit, state, getters }, payload) => {
    return axios({
      url: API_BASE_URL + MEMBERS_DELETE_MEMBER_URL + payload.id,
      method: 'DELETE',
      headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
    })
  }
}

export default { state, getters, mutations, actions }